import { render, staticRenderFns } from "./UserExcludeFromAvailableSetup.vue?vue&type=template&id=01e804bc&"
import script from "./UserExcludeFromAvailableSetup.vue?vue&type=script&lang=ts&"
export * from "./UserExcludeFromAvailableSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports